import type { ScaData } from '@/types/quickPay';

/**
 * Gets the browser width using multiple methods to ensure accuracy
 */
export function getBrowserWidth(): number {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  );
}

/**
 * Builds SCA (Strong Customer Authentication) data for payment processing
 */
export function buildScaData(): ScaData {
  const isJavaEnabled = navigator.javaEnabled() ? 1 : 0;
  const validColorDepthValues = [1, 4, 8, 15, 16, 24, 32, 48];
  const colorDepth = validColorDepthValues.includes(screen.colorDepth)
    ? screen.colorDepth
    : validColorDepthValues.sort((a, b) => Math.abs(screen.colorDepth - a) - Math.abs(screen.colorDepth - b))[0];

  return {
    timeZoneOffset: new Date().getTimezoneOffset(),
    browserScreenHeight: screen.height,
    browserScreenWidth: getBrowserWidth(),
    browserJavascriptEnabled: isJavaEnabled,
    browserColorDepth: colorDepth,
    browserLanguage: window.navigator.language,
    browserUserAgent: window.navigator.userAgent,
  };
}